import React from "react";
import {Tooltip} from "react-tippy";

function TooltipIcon({children, tooltip, theme = "light", position = "top-start"}) {
    return <div className="tooltip-info">
        <Tooltip
            html={(
                <div className="tooltip-info__content">
                    {tooltip}
                </div>
            )}
            animation="fade"
            position={position}
            trigger="mouseenter"
            theme={theme}
            arrow={true}
            delay={10}
        >
            {children}
        </Tooltip>
    </div>;
}

export default TooltipIcon;